export default __webpack_public_path__ + "static/media/marriage.efa0eb49.jpg";